 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import XHTMLCOVER from '@/components/xhtml/cover'
 import XHTMLPRAISEFORTHEBOOKOFKNIGHTS from '@/components/xhtml/PraiseforTheBookofKnights'
 import XHTMLLOVE_1 from '@/components/xhtml/love_1'
 import XHTMLTITLE from '@/components/xhtml/title'
 import XHTMLPACKAGE_NOTICE from '@/components/xhtml/package_notice'
 import XHTMLCOPYRIGHT from '@/components/xhtml/copyright'
 import XHTMLHALF_DEDICATION from '@/components/xhtml/half_dedication'
 import XHTMLHALF_TITLE from '@/components/xhtml/half_title'
 import XHTMLTHEBOOK from '@/components/xhtml/TheBook'
 import XHTMLTHEDOLL from '@/components/xhtml/THEDOLL'
 import XHTMLTHEHOUSEOFRIANDER from '@/components/xhtml/THEHOUSEOFRIANDER'
 import XHTMLTHEPRICEOFTRAINING from '@/components/xhtml/THEPRICEOFTRAINING'
 import XHTMLADEADFRIEND from '@/components/xhtml/ADEADFRIEND'
 import XHTMLGREENANDGRAY from '@/components/xhtml/GREENANDGRAY'
 import XHTMLTHERIDDLEOFTHEWITCH from '@/components/xhtml/THERIDDLEOFTHEWITCH'
 import XHTMLTHEINNOFTHEFIVEWINDS from '@/components/xhtml/THEINNOFTHEFIVEWINDS'
 import XHTMLTHESHIPOFYELDRED from '@/components/xhtml/THESHIPOFYELDRED'
 import XHTMLWITHOSSU from '@/components/xhtml/WITHOSSU'
 import XHTMLADREAMINHARKOVAR from '@/components/xhtml/ADREAMINHARKOVAR'
 import XHTMLTHEQUEENOFTHEFOREST from '@/components/xhtml/THEQUEENOFTHEFOREST'
 import XHTMLTHETOYMAKER from '@/components/xhtml/THETOYMAKER'
 import XHTMLSIRADELRUNEOFFAUDACE from '@/components/xhtml/SIRADELRUNEOFFAUDACE'
 import XHTMLLOVE_2 from '@/components/xhtml/love_2'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/xhtml/cover",
 			"name" : "xhtml/cover",
 			"component" : XHTMLCOVER
 		},
 		{
 			"path" : "/xhtml/PraiseforTheBookofKnights",
 			"name" : "xhtml/PraiseforTheBookofKnights",
 			"component" : XHTMLPRAISEFORTHEBOOKOFKNIGHTS
 		},
 		{
 			"path" : "/xhtml/love_1",
 			"name" : "xhtml/love_1",
 			"component" : XHTMLLOVE_1
 		},
 		{
 			"path" : "/xhtml/title",
 			"name" : "xhtml/title",
 			"component" : XHTMLTITLE
 		},
 		{
 			"path" : "/xhtml/package_notice",
 			"name" : "xhtml/package_notice",
 			"component" : XHTMLPACKAGE_NOTICE
 		},
 		{
 			"path" : "/xhtml/copyright",
 			"name" : "xhtml/copyright",
 			"component" : XHTMLCOPYRIGHT
 		},
 		{
 			"path" : "/xhtml/half_dedication",
 			"name" : "xhtml/half_dedication",
 			"component" : XHTMLHALF_DEDICATION
 		},
 		{
 			"path" : "/xhtml/half_title",
 			"name" : "xhtml/half_title",
 			"component" : XHTMLHALF_TITLE
 		},
 		{
 			"path" : "/xhtml/TheBook",
 			"name" : "xhtml/TheBook",
 			"component" : XHTMLTHEBOOK
 		},
 		{
 			"path" : "/xhtml/THEDOLL",
 			"name" : "xhtml/THEDOLL",
 			"component" : XHTMLTHEDOLL
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js